// Lazy images inside an overflow-clipped track (sliders, pinned collages) only
// start loading once they are on screen, so slides moved in by GSAP flash
// empty. Switch them to eager once the container is about a viewport away.
// Images are queried when that happens, so clones made after init are included.
export function eagerLoadNearView(container, margin = '100%') {
    if (!container || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        container.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
        });
    }, { rootMargin: `${margin} 0px` });

    observer.observe(container);
}
